import { IAppConfiguration } from "../cemexng2components/components/app-configuration";

export default [
  {
    feature: "reports.account-statement",
    country: ["MX", "US", "CO", "PA", "CR", "NI", "SV", "GT", "DO", "PR", "PE", "EG", "AE", "SE", "NO", "IL"],
  },
  {
    feature: "reports.account-statement.jobsite",
    country: ["MX", "PA", "CR", "ES", "LV", "CO", "NI", "SV", "GT", "DO", "PR", "PE", "AE"],
  },
  {
    feature: "reports.account-statement.document-type",
    country: ["MX", "PA", "CR", "ES", "LV", "AE"],
  },
  {
    feature: "reports.account-statement.period",
    country: ["ES", "LV"],
  },
  {
    feature: "reports.account-statement.datepicker",
    country: ["MX", "PA", "CR", "AE"],
    options: {
      max_range_days: 90,
    },
  },
  {
    feature: "reports.account-statement.datepicker",
    country: ["EG"],
    options: {
      max_range_days: 180,
    },
  },
  {
    feature: "reports.account-statement.datepicker",
    country: ["IL"],
    options: {
      max_range_days: 366,
      min_range_year: 2013,
    },
  },
  {
    feature: "reports.account-statement.datepicker",
    country: ["PR"],
    options: {
      max_range_days: 1,
      enable_future: true,
    },
  },
  {
    feature: "reports.account-statement.month-year",
    country: ["US"],
  },
  {
    feature: "reports.account-statement.send-by-email",
    country: ["CO", "NI", "SV", "PA", "CR", "GT", "DO", "PR", "PE"],
    options: {
      document_type: "SP",
    },
  },
  {
    feature: "reports.account-statement.send-by-email",
    country: ["EG"],
    options: {
      document_type: "SC",
    },
  },
  {
    feature: "reports.account-statement.download-and-email",
    country: ["MX", "US"],
  },
  {
    feature: "reports.account-statement.download-only",
    country: ["IL"],
    options: {
      document_type: "SC",
    },
  },
  {
    feature: "reports.account-statement.enabled-download-by-default",
    country: ["US", "IL"],
  },
  {
    feature: "reports.account-statement.only-st-document-type",
    country: ["US"],
  },
  {
    feature: "reports.account-statement.exclude-sd-document-type",
    country: ["CR", "PA"],
  },
  {
    feature: "reports.account-statement.exclude-sc-document-type",
    country: ["AE"],
  },
  {
    feature: "reports.detailed-tickets",
    country: [
      "MX",
      "US",
      "CO",
      "GB",
      "DE",
      "FR",
      "PA",
      "CR",
      "NI",
      "SV",
      "ES",
      "LV",
      "IL",
      "PE",
      "GT",
      "DO",
      "PR",
      "PE",
      "PH",
      "PL",
      "CZ",
      "EG",
      "AE",
    ],
  },
  {
    feature: "reports.detailed-tickets-v2",
    country: [
      "MX",
      "US",
      "CO",
      "GB",
      "DE",
      "FR",
      "PA",
      "CR",
      "NI",
      "SV",
      "ES",
      "LV",
      "IL",
      "PE",
      "GT",
      "DO",
      "PR",
      "PE",
      "PH",
      "PL",
      "CZ",
      "EG",
      "AE",
    ],
  },
  {
    feature: "reports.detailed-tickets-date-picker",
    country: ["PH"],
  },
  {
    feature: "reports.detailed-tickets-v2-download-only",
    // country: [
    //   "MX",
    //   "US",
    //   "CO",
    //   "DE",
    //   "FR",
    //   "PA",
    //   "CR",
    //   "NI",
    //   "SV",
    //   "ES",
    //   "LV",
    //   "IL",
    //   "PE",
    //   "GT",
    //   "DO",
    //   "PR",
    //   "PE",
    //   "PH",
    //   "EG",
    //   "AE",
    //   "CZ",
    //   "GB",
    //   "SE",
    //   "NO",
    // ]
  },
  {
    feature: "reports.detailed-tickets-v2-download-and-email-default-v2",
    country: [
      "MX",
      "US",
      "CO",
      "DE",
      "FR",
      "PA",
      "CR",
      "NI",
      "SV",
      "ES",
      "LV",
      "IL",
      "PE",
      "GT",
      "DO",
      "PR",
      "PE",
      "PH",
      "EG",
      "AE",
      "CZ",
      "GB",
      "SE",
      "NO",
      "PL",
    ],
  },
  {
    feature: "reports.detailed-tickets-v2-enabled-download-by-default",
    // country: [
    //   "MX",
    //   "US",
    //   "CO",
    //   "DE",
    //   "FR",
    //   "PA",
    //   "CR",
    //   "NI",
    //   "SV",
    //   "ES",
    //   "LV",
    //   "IL",
    //   "PE",
    //   "GT",
    //   "DO",
    //   "PR",
    //   "PE",
    //   "PH",
    //   "EG",
    //   "AE",
    //   "CZ",
    //   "GB",
    //   "SE",
    //   "NO",
    // ],
    options: {
      max_range_days: 90,
    },
  },
  {
    feature: "reports.detailed-tickets-v2-send-by-email",
    // country: [
    //   "MX",
    //   "US",
    //   "CO",
    //   "DE",
    //   "FR",
    //   "PA",
    //   "CR",
    //   "NI",
    //   "SV",
    //   "ES",
    //   "LV",
    //   "IL",
    //   "PE",
    //   "GT",
    //   "DO",
    //   "PR",
    //   "PE",
    //   "PH",
    //   "EG",
    //   "AE",
    //   "CZ",
    //   "GB",
    //   "SE",
    //   "NO",
    // ]
  },
  {
    feature: "reports.detailed-tickets-date-picker-v2",
    country: [
      "MX",
      "US",
      "CO",
      "DE",
      "FR",
      "PA",
      "CR",
      "NI",
      "SV",
      "ES",
      "LV",
      "IL",
      "PE",
      "GT",
      "DO",
      "PR",
      "PE",
      "PH",
      "EG",
      "AE",
      "CZ",
      "GB",
      "SE",
      "NO",
      "PL",
    ],
    options: {
      max_range_days: 31,
    },
  },
  {
    feature: "reports.detailed-tickets-period",
    country: ["AE"],
  },
  {
    feature: "reports.detailed-tickets-period-v2",
    // country: ["AE"],
  },
  {
    feature: "reports.detailed-tickets-max-days-range",
    country: ["PH"],
  },
  {
    feature: "reports.detailed-tickets.v8-api",
    country: ["ES", "GB", "FR", "DE", "PL", "CZ"],
  },
  {
    feature: "reports.special-invoice",
    country: ["MX"],
  },
  {
    feature: "reports.printed-tickets",
    country: [
      "MX",
      "US",
      "CO",
      "DE",
      "FR",
      "PA",
      "CR",
      "NI",
      "SV",
      "ES",
      "LV",
      "IL",
      "PE",
      "GT",
      "DO",
      "PR",
      "PE",
      "PH",
      "EG",
      "AE",
      "CZ",
      "GB",
      "SE",
      "NO",
    ],
  },
  {
    feature: "reports.printed-tickets-v2",
    country: [
      "MX",
      "US",
      "CO",
      "DE",
      "FR",
      "PA",
      "CR",
      "NI",
      "SV",
      "ES",
      "LV",
      "IL",
      "PE",
      "GT",
      "DO",
      "PR",
      "PE",
      "PH",
      "EG",
      "AE",
      "CZ",
      "GB",
      "SE",
      "NO",
      "PL",
    ],
  },
  {
    feature: "reports.financial-charge",
    country: ["US"],
  },
  {
    feature: "reports.printed-tickets.merge-pdf",
    role_any:
      "ARMORGAPC, ARMORGARCADV,ARMORGRECONCILE,ARMORGLIEN,ARMORGAPS,ARMORGARU,ARMORGCASH,ARMSTAFFARC,ARMSTAFFDM,ARMSTAFFSR,ARMSTAFFSRCEMENT,ARMSTAFFSRM,ARMSTAFFSRMCEMENT,ARMSTAFFSCONF,Application,OPC_FORMAN,OPC_PO_MGR,OPC_CUST_OWNER",
  },
  {
    feature: "reports.printed-tickets.document-type",
    country: ["US"],
    role_any:
      "ARMORGAPC, ARMORGARCADV,ARMORGRECONCILE,ARMORGLIEN,ARMORGAPS,ARMORGARU,ARMORGCASH,ARMSTAFFARC,ARMSTAFFDM,ARMSTAFFSR,ARMSTAFFSRCEMENT,ARMSTAFFSRM,ARMSTAFFSRMCEMENT,ARMSTAFFSCONF,Application,OPC_FORMAN,OPC_PO_MGR,OPC_CUST_OWNER,ARMSTAFFAPC",
  },
  {
    feature: "reports.printed-tickets.document-type",
    country: [
      "MX",
      "US",
      "CO",
      "DE",
      "FR",
      "PA",
      "CR",
      "NI",
      "SV",
      "ES",
      "LV",
      "IL",
      "PE",
      "GT",
      "DO",
      "PR",
      "PE",
      "PH",
      "EG",
      "AE",
      "CZ",
      "GB",
      "SE",
      "NO",
    ],
    role_any:
      "ARMORGAPC, ARMORGARCADV,ARMORGRECONCILE,ARMORGLIEN,ARMORGAPS,ARMORGARU,ARMORGCASH,ARMSTAFFARC,ARMSTAFFDM,ARMSTAFFSR,ARMSTAFFSRCEMENT,ARMSTAFFSRM,ARMSTAFFSRMCEMENT,ARMSTAFFSCONF,Application,OPC_FORMAN,OPC_PO_MGR,OPC_CUST_OWNER,ARMSTAFFAPC",
  },
  {
    feature: "reports.tax",
    in_rollout: true,
  },
  {
    feature: "reports.printed-delivery.max-files",
    options: {
      max_file: 500,
    },
  },
  {
    feature: "reports.detailed-tickets-v2-management-fees-label",
    country: ["IL"],
  },
  {
    feature: "reports.goods-receipts",
    role_any: ["ARMORGGOODRECEIPT", "ARMSTAFFGOODRECEIPT"],
  },
  {
    feature: "reports.all-cemex-entities",
    country: ["US", "CZ", "DE",  "ES", "FR", "GB", "PL"]
  },
  {
    feature: "reports.internal-users-staff",
    country: ["US"],
    role: "ARMSTAFFMANCRED",
  },
] as IAppConfiguration[];
